import React from 'react';

import Button from '@atlaskit/button';
import AddIcon from '@atlaskit/icon/glyph/add';
import { PopupSelect } from '@atlaskit/select';

export type SelectOption = { label: string; value: string; isEnabled: boolean };
export type SelectOptions = Array<SelectOption>;

export type Props = {
  onChange: (filterValues: Array<{ name: string; value: boolean }>) => void;
  filterOptions: SelectOptions;
  targetClassName?: string;
};

const MoreFiltersSelect: React.FC<Props> = ({
  onChange,
  filterOptions,
  targetClassName,
}: Props) => {
  const handleOnChange = (selectedOption) => {
    onChange([
      { name: selectedOption.value, value: !selectedOption.isEnabled },
    ]);
  };

  return (
    <PopupSelect
      onChange={handleOnChange}
      options={filterOptions}
      target={({ isOpen, ...triggerProps }) => (
        <Button
          {...triggerProps}
          isSelected={isOpen}
          appearance='link'
          className={targetClassName}
          iconBefore={<AddIcon label='More icon' size='small' />}
        >
          More
        </Button>
      )}
    />
  );
};

export default MoreFiltersSelect;
